define("auth/templates/signup/welcome", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tSU--container">
    <div class="tSU--card u--text--center">
      <h1 class="tSU--card__title u--m__t__xs">{{t "authorization.create_account.welcome_title"}}</h1>
      <p class="tSU--card__subTitle u--m__b__xs">{{t "authorization.create_account.welcome_message"}}</p>
    </div>
  </div>
  */
  {
    "id": "haDlVU70",
    "block": "[[[10,0],[14,0,\"tSU--container\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"tSU--card u--text--center\"],[12],[1,\"\\n    \"],[10,\"h1\"],[14,0,\"tSU--card__title u--m__t__xs\"],[12],[1,[28,[35,0],[\"authorization.create_account.welcome_title\"],null]],[13],[1,\"\\n    \"],[10,2],[14,0,\"tSU--card__subTitle u--m__b__xs\"],[12],[1,[28,[35,0],[\"authorization.create_account.welcome_message\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"t\"]]",
    "moduleName": "auth/templates/signup/welcome.hbs",
    "isStrictMode": false
  });
});